import {jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import {Suspense} from 'react'
import {useFragment} from 'react-relay'
import {useHistory} from 'react-router'

import {Loader} from '../../../../utils/relay/renderLoader'
import GitLabProviders from './GitLabProviders'





const OrgIntegrations = (props) => {
  const {organizationRef} = props
  const organization = useFragment(
    graphql`
      fragment OrgIntegrations_organization on Organization {
        id
        ...GitLabProviders_organization
        createdAt
        tier
        viewerOrganizationUser {
          id
          role
        }
        organizationUsers {
          edges {
            node {
              role
            }
          }
        }
      }
    `,
    organizationRef
  )

  const {id: orgId, viewerOrganizationUser, organizationUsers} = organization
  const history = useHistory()
  const isOrgAdmin = _optionalChain([viewerOrganizationUser, 'optionalAccess', _ => _.role]) === 'ORG_ADMIN'

  const orgUsers = _optionalChain([organizationUsers, 'optionalAccess', _2 => _2.edges, 'access', _3 => _3.map, 'call', _4 => _4((edge) => edge.node)])
  const isAnyOrgAdmins = _optionalChain([orgUsers, 'optionalAccess', _5 => _5.some, 'call', _6 => _6((user) => user.role === 'ORG_ADMIN')])

  return (
    _jsx(Suspense, { fallback: _jsx(Loader, {} ), children: 
      _jsx('div', { className: "flex w-full flex-wrap"  , children: 
        _jsxs('div', { className: "w-[768px] max-w-[768px]" , children: [
          _jsx('h1', { children: "Integration Settings" })
          , isOrgAdmin ? (
            _jsxs('div', { className: "text-base text-slate-700" , children: ["Configure organization-level integrations that can be used by teams across your organization."


              , _jsx('br', {} ), "See the team integration tab for team-level connections."

            ]})
          ) : (
            _jsxs('div', { className: "text-slate-700", children: [
              `Organization-level integrations are managed by `
              , _jsx('a', {
                href: "https://www.parabol.co/support/roles-on-parabol",
                className: "font-bold text-sky-500 hover:text-sky-600"  ,
                target: "_blank",
 children: "Org Admins"

              })
              , `.`
              , isAnyOrgAdmins ? (
                _jsxs(_Fragment, { children: [
                  ` View yours `
                  , _jsx('button', {
                    onClick: () => history.push(`/me/organizations/${orgId}/billing`),
                    className: "cursor-pointer bg-transparent p-0 font-bold text-sky-500 hover:text-sky-600"     ,
 children: "here"

                  })
                  , `.`
                ]})
              ) : null
            ]})
          )
          , _jsx(GitLabProviders, { organizationRef: organization,} )
        ]})
      })
    })
  )
}

export default OrgIntegrations
